document.addEventListener("DOMContentLoaded", () => {
  document.addEventListener("click", (e) => {
    let event = e || window.event;
    let target = event.target || event.srcElement;
    // 语言下拉
    if(target.classList.value.indexOf('ug-change-countrylanFn')!=-1){
      if(target.nextElementSibling){
        if(target.nextElementSibling.classList.value.indexOf('dpn')!=-1){
          // 移动端 父级的transform 影响到 国家选择的定位  所以是移动端需要额外处理
          if(target.closest('#menu-drawer')){
            let drawer = target.closest('#menu-drawer');
            drawer.style.overflowY = 'hidden';
            target.nextElementSibling.style.transform = `translateY(${drawer.scrollTop}px)`;
          }
          target.nextElementSibling.classList.remove('dpn');
        }else{
          target.nextElementSibling.classList.add('dpn');
        }
      }
    } else {
      let countrydivList = document.querySelectorAll(
        ".ug-change-countrylanFn-div"
      );
      countrydivList = Array.from(countrydivList);
      countrydivList.forEach((item, k) => {
        if (item.classList.value.indexOf("dpn") == -1) {
          item.classList.add("dpn");
        }
      });
    }

    // // 语言点击
    // if(target.classList.value.indexOf('ug-change-countrylan-item')!=-1){
    //   if(document.querySelector('#Details-menu-drawer-container') && document.querySelector('#Details-menu-drawer-container').classList.value.indexOf('menu-opening')!=-1 ){
    //     if(document.querySelector('.header__icon--menu')){
    //       document.querySelector('.header__icon--menu').click();
    //     }
    //   }

    //   let marketHandle = target.getAttribute('data-marketHandle');
    //   if(marketHandle != window.UgreenInfo.ugmarketHandle ){
    //     let return_to = '';
    //     let country_code = '';
    //     if(marketHandle == 'de'){
    //       return_to = '/de';
    //       country_code = 'DE';
    //     }else{
    //       return_to = '/';
    //       country_code = 'US';
    //     }
    //     fetchLoctionFn(return_to,country_code);
    //   }
    // }
    // 语言点击
    // if (target.classList.value.indexOf("ug-change-countrylan-item") != -1) {
    //   if (
    //     document.querySelector("#Details-menu-drawer-container") &&
    //     document
    //       .querySelector("#Details-menu-drawer-container")
    //       .classList.value.indexOf("menu-opening") != -1
    //   ) {
    //     if (document.querySelector(".header__icon--menu")) {
    //       document.querySelector(".header__icon--menu").click();
    //     }
    //   }

    //   let marketHandle = target.getAttribute("data-marketHandle");
    //   if (marketHandle != window.UgreenInfo.ugmarketHandle) {
    //     let return_to = "";
    //     let country_code = "";
    //     // Get current path and search params
    //     const currentPath = window.location.pathname;
    //     const searchParams = window.location.search;

    //     // Get current domain and check if we're already on the correct site
    //     const currentDomain = window.location.hostname;
    //     const isGermanSite = currentDomain.includes("nas-de");

    //     if (marketHandle != "de" && isGermanSite) {
    //       // Only switch to English site if we're currently on German site
    //       window.location.href =
    //         "https://nas.ugreen.com" + currentPath + searchParams;
    //       return;
    //     }
    //   }
    // }
  });

  function fetchLoctionFn(return_to, country_code) {
    let url = "/localization";
    let senddata = new FormData();
    senddata.set("form_type", "localization");
    senddata.set("utf8", "✓");
    senddata.set("_method", "put");
    senddata.set("return_to", return_to);
    senddata.set("country_code", country_code);
    fetch(url, {
      method: "POST",
      body: senddata,
    })
      .then((response) => response.json())
      .then((data) => {
        window.location.href = return_to;
      })
      .catch((error) => {
        window.location.href = return_to;
      });
  }
  // 跳转 3c nas 统一添加 ip 跳转忽略
  // 监听全局所有的 a 标签
  // document.querySelectorAll("a").forEach(function (anchor) {
  //   anchor.addEventListener("click", function (event) {
  //     // 获取当前的 href
  //     let href = this.getAttribute("href");
  //     // 检查 href 中是否包含 from=nas
  //     if (href && (href.includes("?from=nas") || href.includes("&from=nas"))) {
  //       // 如果 from=nas 存在，检查是否已经有参数 SkipCozyRedirect=yes，如果没有则添加
  //       if (!href.includes("SkipCozyRedirect=yes")) {
  //         // 判断 href 中是否已有其他参数
  //         if (href.includes("?")) {
  //           // 已经有参数的情况下，增加 &a=xxx
  //           href += "&SkipCozyRedirect=yes";
  //         } else {
  //           // 没有其他参数，直接加 ?a=xxx
  //           href += "?SkipCozyRedirect=yes";
  //         }
  //       }

  //       // 阻止默认跳转
  //       event.preventDefault();

  //       // 手动跳转到新构造的 href
  //       window.open(href, "_blank");
  //       // window.location.href = href;
  //     }
  //   });
  // });
  // 跳转 3c nas 统一添加 ip 跳转忽略 end

  // 所有出站链接都需要添加 rel=nofollow 属性
  function otherLinkAddNoFollow() {
    document.querySelectorAll("a").forEach(function (link) {
      const href = link.getAttribute("href");
      if (
        href &&
        href.includes("//") &&
        !href.includes(window.location.hostname)
      ) {
        // 如果是外部链接，添加 rel="nofollow" 属性
        link.setAttribute("rel", "nofollow");
      }
    });
  }
  setTimeout(() => {
    otherLinkAddNoFollow();
  }, 0);
  // 所有出站链接都需要添加 rel=nofollow 属性 end
});
